import { ConversationLoader, ConversationMark } from "../OlliLogo";

const ICON = { sm: "h-8 w-8", md: "h-10 w-10", lg: "h-12 w-12" };
const PILL = { sm: "h-9 px-3.5 text-caption", md: "h-11 px-5 text-small", lg: "h-12 px-6 text-body" };
const MARK = { sm: 20, md: 24, lg: 28 };
const MARK_CLASS = { sm: "h-5 w-5", md: "h-6 w-6", lg: "h-7 w-7" };

/**
 * Every "send to Olli" button: the In conversation mark at rest, the two bubbles talking while it sends.
 * `sending` turns the mark into the talking loader; `label` gives a pill with text, else a round icon button.
 */
export function OlliSendButton({ sending = false, label, sendingLabel = "Sending…", variant = "sun", size = "md", className = "", disabled, type = "submit", ...props }) {
  const tone = variant === "sun" ? "yellow" : "black";
  const color = variant === "sun" ? "bg-sun text-ink hover:brightness-95" : "bg-ink text-paper hover:bg-ink/85";
  const shape = label ? `${PILL[size]} gap-2 rounded-full font-semibold` : `${ICON[size]} justify-center rounded-full`;
  const markSize = MARK[size];
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || sending}
      aria-busy={sending || undefined}
      aria-label={props["aria-label"] ?? (sending ? sendingLabel : label ?? "Send to Olli")}
      className={`flex shrink-0 items-center ${shape} ${color} disabled:cursor-not-allowed ${sending ? "" : "disabled:opacity-40"} ${className}`}
    >
      {sending ? (
        <span className="animate-fade-in flex items-center gap-2">
          <ConversationLoader size={markSize} tone={tone} />
          {label && <span>{sendingLabel}</span>}
        </span>
      ) : (
        <>
          <ConversationMark tone={tone} className={`shrink-0 ${MARK_CLASS[size]}`} />
          {label && <span>{label}</span>}
        </>
      )}
    </button>
  );
}
